import React from 'react';
import './VideosCount.css';


const VideosCount = (props) => {
  const { ready, count } = props;

  return ready ? (
    <div id="anchor-video-archive-count">
      {count > 0 && (
        <span>{count} { count > 1 ? 'videos' : 'video' }</span>
      )}
    </div>
  ) : null;
};

export default VideosCount;
